import Donut from './seatIcons/Donut';
import Circle from './seatIcons/Circle';
import Wheelchair from './seatIcons/Wheelchair';
import Star from './seatIcons/Star';
import dom from '../utils/dom';
import SyosGlobalConfig from './SyosGlobalConfig';
import SyosPageComponent from './SyosPageComponent';

/** @typedef {import("../tnew/currency/CurrencyFormatter").default} CurrencyFormatter */


function makeIconTermWithDetails(iconSvgMarkup, htmlContent, color = '#000') {
  return `
    <div class="tn-syos-legend__description-group">
      <dt class="tn-syos-legend__description-term" style="color: ${color};">${iconSvgMarkup}</dt>
      <dd class="tn-syos-legend__description-details">
        <div class="tn-syos-legend__description-details-content">
          ${htmlContent}
        </div>
      </dd>
    </div>
  `;
}

function makeZoneListHtml(zones, currencyFormatter) {
  const {
    legendShouldRenderPriceRange: renderPriceRange,
    legendShouldRenderPricetypeList: renderPricetypeList,
  } = SyosGlobalConfig;

  const zoneListItemsHtml = zones.map((zone) => {
    const zoneLabelHtml = `<div class="tn-syos-legend__zone-label">${zone.label}</div>`;

    const zonePriceRangeHtml = makeZonePriceRangeHtml(renderPriceRange, zone, currencyFormatter);

    const pricetypeListHtml = makeZonePricetypeListHtml(renderPricetypeList, zone, currencyFormatter);

    const zoneHtmlContent = zoneLabelHtml + zonePriceRangeHtml + pricetypeListHtml;

    return makeIconTermWithDetails(Circle.getSvgMarkup(`Color for ${zone.label}`), zoneHtmlContent, zone.color);
  });

  return `
    <dl class="tn-syos-legend__zone-list">
      ${zoneListItemsHtml.join('')}
    </dl>`;
}

function makeZonePricetypeListHtml(shouldRender, zone, currencyFormatter) {
  if (!shouldRender) {
    return '';
  }

  const pricetypeItemsHtml = zone.priceTypes.map(priceType => `
    <li class="tn-syos-legend__zone-pricetype-list-item">
      <span class="tn-syos-legend__zone-pricetype-label">${priceType.price_type_desc}</span>
      <span class="tn-syos-legend__zone-pricetype-price">${currencyFormatter.format(priceType.priceWithFee)}</span>
    </li>`);

  const headingId = `tn-syos-legend-zone-pricetype-list-heading-${zone.id}`;

  return `
    <h5 id="${headingId}" class="sr-only">Price by ticket type for ${zone.label}</h5>
    <ul class="tn-syos-legend__zone-pricetype-list" aria-labeledby="${headingId}">
      ${pricetypeItemsHtml.join('')}
    </ul>`;
}

function makeZonePriceRangeHtml(shouldRender, zone, currencyFormatter) {
  if (!shouldRender) {
    return '';
  }

  const range = zone.priceRange;

  let value = `<span class="tn-syos-legend__zone-price-range-min-price">${currencyFormatter.format(range[0])}</span>`;

  if (range.length > 1) {
    value += `<span class="tn-syos-legend__zone-price-range-max-price">${currencyFormatter.format(range[range.length - 1])}</span>`;
  }

  return `
    <div class="tn-syos-legend__zone-price-range">
      <span class="sr-only">Price:</span>
      ${value}
    </div>`;
}


function makeSeatTypeListHtml(seatTypes) {
  const icons = [
    { svgMarkup: Circle.getSvgMarkup('Solid light-gray circle'), description: SyosPageComponent.labelSeatStatusUnavailable, color: '#CCC' },
    { svgMarkup: Donut.getSvgMarkup(), description: SyosPageComponent.labelSeatStatusSelected },
  ];

  if (seatTypes.includes('Wheelchair')) {
    icons.push({ svgMarkup: Wheelchair.getSvgMarkup(), description: SyosPageComponent.labelSeatTypeWheelchair });
  }

  if (seatTypes.includes('Special')) {
    icons.push({ svgMarkup: Star.getSvgMarkup(), description: SyosPageComponent.labelSeatTypeSpecial });
  }

  const listItemsHtml = icons
    .map(icon => makeIconTermWithDetails(icon.svgMarkup, icon.description, icon.color));

  return `
    <dl class="tn-syos-legend__seat-type-list">
      ${listItemsHtml.join('')}
    </dl>`;
}


class SyosLegendRenderer {
  /**
   * @param {CurrencyFormatter} currencyFormatter
   */
  constructor(currencyFormatter) {
    this.currencyFormatter = currencyFormatter;
  }

  render(legendData) {
    const { currencyFormatter } = this;
    const $el = dom.makeElement('div', { class: 'tn-syos-legend', tabIndex: -1 });

    const zoneListHtml = makeZoneListHtml(legendData.zones, currencyFormatter);
    const iconListHtml = makeSeatTypeListHtml(legendData.seatTypes, currencyFormatter);

    $el.innerHTML = `
      <h4 class="sr-only">Sections by Color</h4>
      ${zoneListHtml}

      <h4 class="sr-only">Seat Type Icons</h4>
      ${iconListHtml}`;

    return $el;
  }
}

export default SyosLegendRenderer;



// WEBPACK FOOTER //
// ./V7/syos/SyosLegendRenderer.js